import { lazy, Suspense } from 'react';

/**
 * TanStack Query Devtools, in development only (docs/07-implementation-roadmap.md
 * F0.3).
 *
 * `import.meta.env.DEV` is replaced with a literal at build time, so in a
 * production build the ternary below folds to `null` and the dynamic import is
 * dropped with it — the devtools never reach the bundle staff download, and
 * F-DoD-7's budget never has to account for them. Guarding inside the component
 * instead would keep the import reachable and ship the chunk anyway.
 */
const LazyDevtools = import.meta.env.DEV
  ? lazy(() => import('@tanstack/react-query-devtools').then((module) => ({ default: module.ReactQueryDevtools })))
  : null;

export function Devtools() {
  if (!LazyDevtools) return null;

  return (
    <Suspense fallback={null}>
      <LazyDevtools initialIsOpen={false} />
    </Suspense>
  );
}
